/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { AeroModule } from '../../aero/aero.module';

// Our custom Angular Components
import { CopyTemplateDialogComponent } from './copy-template-dialog/copy-template-dialog.component';
import { TagsDialogComponent } from './tags-dialog/tags-dialog.component';
import { TagsComponent } from './tags/tags.component';
import { TagsStudentDialogComponent } from './tags-student-dialog/tags-student-dialog.component';
import { BulbCommonModule } from '../../common/bulb-common.module';

/**
 * Bulb Organization module.
 */
@NgModule({
  declarations: [
    CopyTemplateDialogComponent,
    TagsDialogComponent,
    TagsStudentDialogComponent,
    TagsComponent,
  ],
  imports: [
    AeroModule,
    CommonModule,
    MultiSelectModule,
    AccordionModule,
    SvgIconComponent,
    TranslocoModule,
    FormsModule,
    ReactiveFormsModule,
    TabViewModule,
    TableModule,
    BulbCommonModule,
  ],
  exports: [
    CopyTemplateDialogComponent,
    TagsDialogComponent,
    TagsStudentDialogComponent,
    TagsComponent,
  ],
  providers: [],
})
export class OrganizationModule {
}
